"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.mapToEscapeKeyIsDown = void 0;
var map_to_target_key_is_down_1 = require("../map-to-target-key-is-down");
var mapToEscapeKeyIsDown = function () { return function (keyEvents$) { return keyEvents$.pipe((0, map_to_target_key_is_down_1.mapToTargetKeyIsDown)('Escape')); }; };
exports.mapToEscapeKeyIsDown = mapToEscapeKeyIsDown;
